import axiosInstance from "./axiosInstance";

const adminService = {
  login: async (payload) => {
    try {
      const response = await axiosInstance.post("admin/users/login", payload);
      console.log("Response from login API:", response);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAllRoles: async () => {
    try {
      const response = await axiosInstance.get("admin/users/roles");
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAllAdminPanelUsers: async (page, requestOpts = {}) => {
    try {
      const response = await axiosInstance.get(
        `admin/users/admin-panel-users/${page}`,
        { signal: requestOpts.signal }
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  createAdminPanelUser: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/register",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAdminPanelUserById: async (id) => {
    try {
      const response = await axiosInstance.get(
        `admin/users/admin-panel-user/${id}`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  updateAdminPanelUser: async (id, payload) => {
    try {
      const response = await axiosInstance.put(
        `admin/users/admin-panel-user/${id}`,
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  updateMyAgentTitle: async (agentTitle) => {
    try {
      const response = await axiosInstance.put("admin/users/me/agent-title", {
        agent_title: agentTitle,
      });
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  deleteAdminPanelUser: async (id) => {
    try {
      const response = await axiosInstance.delete(
        `admin/users/admin-panel-user/${id}`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  logout: async () => {
    try {
      const response = await axiosInstance.post("admin/users/logout");
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  sendFilteredNotification: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/send-filtered-notification",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getScheduledNotifications: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.status) queryParams.append("status", params.status);
      if (params.startDate) queryParams.append("startDate", params.startDate);
      if (params.endDate) queryParams.append("endDate", params.endDate);

      const queryString = queryParams.toString();
      const url = `admin/users/scheduled-notifications${
        queryString ? `?${queryString}` : ""
      }`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  cancelScheduledNotification: async (id) => {
    try {
      const response = await axiosInstance.delete(
        `admin/users/scheduled-notifications/${id}`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getDistinctCountries: async () => {
    try {
      const response = await axiosInstance.get(
        "admin/users/distinct-countries"
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getNotificationHistory: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.type) queryParams.append("type", params.type);
      if (params.category) queryParams.append("category", params.category);
      if (params.startDate) queryParams.append("startDate", params.startDate);
      if (params.endDate) queryParams.append("endDate", params.endDate);

      const queryString = queryParams.toString();
      const url = `admin/users/notification-history${
        queryString ? `?${queryString}` : ""
      }`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  // Promotional messaging methods
  getBoostHistory: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.user_id) queryParams.append("user_id", params.user_id);
      if (params.action) queryParams.append("action", params.action);
      if (params.start_date)
        queryParams.append("start_date", params.start_date);
      if (params.end_date) queryParams.append("end_date", params.end_date);
      if (params.search) queryParams.append("search", params.search);

      const queryString = queryParams.toString();
      const url = `admin/users/boost-history${
        queryString ? `?${queryString}` : ""
      }`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAllSubscriptions: async (params = {}, signal = null) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.user_id) queryParams.append("user_id", params.user_id);
      if (params.name) queryParams.append("name", params.name);
      if (params.email) queryParams.append("email", params.email);
      if (params.contactNo) queryParams.append("contactNo", params.contactNo);
      if (params.date_from) queryParams.append("date_from", params.date_from);
      if (params.date_to) queryParams.append("date_to", params.date_to);
      if (params.subscription) queryParams.append("subscription", params.subscription);
      if (params.source) queryParams.append("source", params.source);
      if (params.record_state) queryParams.append("record_state", params.record_state);
      if (params.payment_method) queryParams.append("payment_method", params.payment_method);
      if (params.currency) queryParams.append("currency", params.currency);
      if (params.status) queryParams.append("status", params.status);
      if (params.emailType) queryParams.append("emailType", params.emailType);
      if (params.account_deleted) queryParams.append("account_deleted", params.account_deleted);
      const queryString = queryParams.toString();
      const url = `admin/users/subscriptions${queryString ? `?${queryString}` : ""}`;
      const config = signal ? { signal } : {};
      const response = await axiosInstance.get(url, config);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  deleteSubscriptionRecord: async (id) => {
    try {
      const response = await axiosInstance.delete(`admin/users/subscriptions/${id}`);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  updateSubscriptionRecord: async (id, payload) => {
    try {
      const response = await axiosInstance.patch(`admin/users/subscriptions/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getSubscriptionPlans: async () => {
    try {
      const response = await axiosInstance.get("admin/users/subscription-plans");
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  searchUsersForSubscription: async (q) => {
    try {
      const params = new URLSearchParams();
      if (q) params.append("q", q);
      const url = `admin/users/search-users${params.toString() ? `?${params.toString()}` : ""}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  purchaseSubscriptionByEmail: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "subscription/purchase-by-email",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  expireUserPremium: async (userId) => {
    try {
      const response = await axiosInstance.post(`admin/users/${userId}/expire-premium`);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getBoostPackages: async () => {
    try {
      const response = await axiosInstance.get("admin/users/boost-packages");
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getUserBoostStatus: async (userId) => {
    try {
      const response = await axiosInstance.get(`admin/users/${userId}/boost-status`);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  grantUserBoost: async (userId, payload) => {
    try {
      const response = await axiosInstance.post(`admin/users/${userId}/grant-boost`, payload);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  searchUserForPromotionalMessage: async (email = null, contactNo = null) => {
    try {
      const queryParams = new URLSearchParams();
      if (email) queryParams.append("email", email);
      if (contactNo) queryParams.append("contactNo", contactNo);

      const queryString = queryParams.toString();
      const url = `admin/users/promotional/search-user${
        queryString ? `?${queryString}` : ""
      }`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  sendPromotionalMessageToUser: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/promotional/send-to-user",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  sendPromotionalMessageToAll: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/promotional/send-to-all",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  uploadPromotionalVideo: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        "admin/users/promotional/upload/video",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },

  // Dummy users module (create & list credentials)
  createDummyUsersAuto: async (count, gender, country) => {
    try {
      const response = await axiosInstance.post(
        "admin/dummy-users/auto",
        { count, gender: gender || undefined, country: country || undefined }
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  createDummyUserManual: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/dummy-users/manual",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getDummyUserCredentials: async (params = {}, requestOpts = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      const queryString = queryParams.toString();
      const url = `admin/dummy-users${queryString ? `?${queryString}` : ""}`;
      const response = await axiosInstance.get(url, { signal: requestOpts.signal });
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getDummyUserCredentialsExport: async (ids = null) => {
    try {
      const url = ids && ids.length > 0
        ? `admin/dummy-users/export?ids=${ids.join(",")}`
        : "admin/dummy-users/export";
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },

  getReferralRedemptions: async (params = {}) => {
    try {
      const q = new URLSearchParams();
      if (params.page) q.append("page", params.page);
      if (params.limit) q.append("limit", params.limit);
      const response = await axiosInstance.get(
        `admin/users/referrals/redemptions${q.toString() ? `?${q}` : ""}`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  deleteReferralRedemption: async (id) => {
    try {
      const response = await axiosInstance.delete(`admin/users/referrals/redemptions/${id}`);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
};

export default adminService;
